import Translations from "@/lib/Translations";
import { Pad } from "../Misc";

const $t = Translations.Get;

const DateTime = {};

DateTime.ConvertDateToHumanReadable = (
    input,
    day = true,
    date = true,
    month = true,
    year = true,
    short = false
) => {
    let stamp = [];

    if (day) {
        if (short) {
            stamp.push($t(DateTime.GetShortDayName(input.getDay())));
        } else {
            stamp.push($t(DateTime.GetDayName(input.getDay())));
        }
    }

    if (date) {
        stamp.push(input.getDate());
    }

    if (month) {
        if (short) {
            stamp.push(DateTime.GetShortMonthName(input.getMonth()));
        } else {
            stamp.push(DateTime.GetMonthName(input.getMonth()));
        }
    }

    if (year) {
        stamp.push(input.getFullYear());
    }

    return stamp.join(" ");
};

DateTime.DayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

/**
 * Converts string to new Date() object
 * ! Replaces spaces to "T" to support iOS
 *
 * @param   {string}  input  Input datestamp
 *
 * @return  {Date}           Date
 */
DateTime.Date = (input) => {
    if (typeof input === "string" || input instanceof String) {
        return new Date(input.replace(" ", "T"));
    }

    return new Date(input);
};

DateTime.ShortDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

DateTime.GetDayName = (dayIndex) => DateTime.DayNames[dayIndex];

DateTime.GetShortDayName = (dayIndex) => DateTime.ShortDayNames[dayIndex];

DateTime.MonthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

DateTime.GetMonthName = (monthIndex) => $t(DateTime.MonthNames[monthIndex]);

DateTime.ShortMonthNames = [
    "jan",
    "feb",
    "mrt",
    "apr",
    "mei",
    "jun",
    "jul",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec",
];

DateTime.GetShortMonthName = (monthIndex) =>
    $t(DateTime.ShortMonthNames[monthIndex]);

DateTime.now = () => new Date();

DateTime.nowWithoutTime = () => {
    const now = DateTime.now();
    now.setSeconds(0);
    now.setMinutes(0);
    now.setHours(0);
    now.setMilliseconds(0);

    return now;
};

DateTime.ParseDate = (day, month, year) => {
    return `${Pad(day, 2)}-${Pad(month, 2)}-${year}`;
};

DateTime.FormatToDate = (date) => {
    let month = date.getMonth() + 1; // Month starts counting from 0 so we at 1
    month = Pad(month, 2);

    const day = Pad(date.getDate(), 2);

    return `${day}-${month}-${date.getFullYear()}`;
};

DateTime.GetNextDays = (count, input = null) => {
    if (!input) {
        input = DateTime.nowWithoutTime();
    }
    const dates = [];

    for (let i = 0; i < count; i++) {
        const date = new Date(input.getTime());
        date.setDate(date.getDate() + i);
        dates.push(date);
    }

    return dates;
};

/**
 * Gets weeknumber by date
 *
 * @param   {Date}    input Date object
 *
 * @return  {Number}        Returns associated weeknumber
 */
DateTime.getWeekNumber = (input) => {
    let date = new Date(input.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    let week1 = new Date(date.getFullYear(), 0, 4);

    return (
        1 +
        Math.round(
            ((date.getTime() - week1.getTime()) / 86400000 -
                3 +
                ((week1.getDay() + 6) % 7)) /
                7
        )
    );
};

/**
 *
 * @param {Number} weekNumber
 * @returns
 */
DateTime.getFormattedDateOfWeek = (weekNumber) => {
    const year = DateTime.now().getFullYear();
    const ISOweekStart = new Date(year, 0, 1 + (weekNumber - 1) * 7);
    const ISOWeekEnd = new Date(year, 0, 1 + (weekNumber - 1) * 7);

    ISOweekStart.setDate(ISOweekStart.getDate() - ISOweekStart.getDay() + 1);
    ISOWeekEnd.setDate(ISOWeekEnd.getDate() - ISOWeekEnd.getDay() + 7);

    const formattedStartDay = DateTime.ConvertDateToHumanReadable(
        ISOweekStart,
        false,
        true,
        true,
        false,
        true
    );
    const formattedEndDay = DateTime.ConvertDateToHumanReadable(
        ISOWeekEnd,
        false,
        true,
        true,
        false,
        true
    );

    return formattedStartDay + " - " + formattedEndDay;
};

export default DateTime;
